// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6c649102","453":"a24132cc","455":"7f4483af","977":"59af7ee3"}[chunkId] + ".chunk.js";
};